import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "284",
  "slug": "spot-france-from-satellite-imagery",
  "title": "How to Recognise France in Satellite Images",
  "excerpt": "In metropolitan France, the Alps mark the southeast and the Pyrenees the southwest.",
  "date": "2026-05-15",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/france.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "In metropolitan France, the Alps mark the southeast and the Pyrenees the southwest. Lower country extends across much of the north and west, with the Massif Central inland. Brittany projects into the Atlantic, while the Mediterranean coast follows a different orientation."
    },
    {
      "type": "heading",
      "text": "Plains, uplands, and two mountain borders"
    },
    {
      "type": "paragraph",
      "text": "Locate Brittany, then compare the Atlantic coast with the Mediterranean side. This regional overview covers metropolitan France rather than its overseas territories."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Fields divided by hedges occur in Britain and Ireland too. Vineyards are not exclusive to France, and crop type can be difficult to establish from an overhead image. A recognisable peninsula or mountain front is stronger evidence."
    }
  ],
  "imageAlt": "France regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
